import {Router} from './router/router'

export const App = () => {
  return (
    <Router/>
  );
}

